import type { ChatConversation } from "@/services/caseChatServiceV2.types";
import { getErrorMessage } from "@/utils/errorUtils";
import useSWR, { mutate } from "swr";

import { useCaseChatService } from "./useCaseChatService";

const CASE_CHATS_KEY = "/case-chats";

export const useCaseChats = (caseId: string | undefined) => {
  const service = useCaseChatService();
  const cacheKey = caseId ? [CASE_CHATS_KEY, caseId] : null;

  const {
    data: conversations,
    error,
    isLoading,
  } = useSWR<ChatConversation[]>(cacheKey, () => service.listConversations(caseId!), {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    dedupingInterval: 10_000,
  });

  return {
    conversations: conversations ?? [],
    isLoading,
    error: error ? getErrorMessage(error) : null,
  };
};

export const invalidateCaseChatsCache = (caseId?: string) => {
  if (caseId) {
    mutate([CASE_CHATS_KEY, caseId]);
  } else {
    mutate((key: unknown) => Array.isArray(key) && key[0] === CASE_CHATS_KEY, undefined, {
      revalidate: true,
    });
  }
};
